<template>
	<div class="hd-mod-frame-virus-infusion">
		<base-image-svg
			class="js-mod-frame-virus-infusion hd-mod-frame-virus-infusion__svg"
			:source="require('!html-loader!../../assets/svgs/10-mod-frame-virus-infusion.svg')"
		/>
		<!-- TODO: update mobile version -->
		<base-image-svg
			class="js-mod-frame-virus-infusion hd-mod-frame-virus-infusion__svg--mobile"
			:source="require('!html-loader!../../assets/svgs/10-mod-frame-virus-infusion-mobile.svg')"
		/>
	</div>
</template>

<style lang="scss" scoped>
	.hd-mod-frame-virus-infusion {
		position: absolute;
		left: 0;
		bottom: 0;
		@include box(100%);

		&__svg {
			&--mobile.hd-base-image-svg {
				display: none;
			}
		}

		:deep() svg {
			position: absolute;
			left: 0;
			bottom: -50px;
			width: 100%;

			@include fade-out();

			#Nucleocapsids,
			#Genetic_Material,
			#RNA_entering {
				@include fade-out();
				@include animation-float-mini();
			}

			#Fusion_Machinery,
			#mod-infusion-labels {
				@include fade-out();
			}
		}

		// Animations
		[data-state="animation-ready"] {
			:deep() svg {
				opacity: 1;

				#Nucleocapsids,
				#Genetic_Material {
					opacity: 1;
					transition-delay: 0.25s;				
				}

				#Fusion_Machinery,
				#mod-infusion-labels {
					opacity: 1;
					transition-delay: 0.5s;	
				}

				#RNA_entering {
					opacity: 1;
					transition-delay: 1s;	
				}
			}
		}

		[data-state="animation-leave"] {
			:deep() svg {
				@include animation-frame-zoom-out();
			}
		}

		// Responsive 
		@include res-screen-small {
			:deep() svg {
				bottom: -130px;
			}
		}

		@include res-screen-x-small {
			:deep() svg {
				bottom: -190px;
			}
		}

		@include res-screen-portrait {
			:deep() svg {
				bottom: auto;
				top: 100px;
			}
		}
		@include res-screen-portrait-sm {
			&__svg {
				display: none;

				&--mobile.hd-base-image-svg {
					display: flex;
				}
			}

			:deep() svg {
				bottom: auto;
				top: 39%;
			}
		}
	}
</style>

